export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtDphSazba';
export const NAME = 'SazbaDph';
